import React from "react";
import { HeaderVariant } from "ui/blocks/HeaderVariant/HeaderVariant";
import { ScrollToTop } from "../ui/base/ScrollToTop";
import { AgreementsView } from "../ui/blocks/AgreementsView";

const PolicyPage = () => {
  return (
    <ScrollToTop>
      <HeaderVariant />
      <AgreementsView />
    </ScrollToTop>
  );
};

export default PolicyPage;
